<router-outlet></router-outlet>
<app-toast-message></app-toast-message>
<!-- <p-toast position="top-right"></p-toast> -->

<chicilon-global-toast />

<p-confirmDialog></p-confirmDialog>

<p-drawer />

<chicilon-full-screen-loading [isLoading]="(isLoading$ | async) ?? false" />
